<template>
  <div class="dashboard__card" v-cloak>
    <CardLoading v-if="loaders.fuelFunds"></CardLoading>
    <div class="dashboard__card-content" :class="{ 'loadingBlur': loaders.fuelFunds }" v-cloak>
      <div class="dashboard__card-header">
        <div class="dashboard__card-title">Fuel Funds <span class="h-italic-text h-helper-text"><a @click.stop="activateModal">(Terms and Conditions)</a></span></div>
        <div class="dashboard__card-title-icon dashboard__card-title-icon--fuel-funds"><i class="fa fa-dollar-sign"></i></div>
      </div>

      <div class="row dashboard__card-body dashboard__card-body--bordered" v-if="totalAvailable" v-cloak>
        <div class="dashboard__grid dash-fuel-funds__content-container">
          <div class="col-sm-9 dashboard__card-body-col dash-fuel-funds__content-col-container">
            <div class="fuel-funds-card__available h-center-align">
              <div class="dash-fuel-funds__total" v-cloak>
                <span class="dash-fuel-funds__dollar-sign h-big-dollar-sign">$</span>{{ totalAvailable }}
              </div>
              <div class="h-available">Available</div>
            </div>
          </div>
          <div class="col-sm-3 dashboard__card-body-col dashboard__card-body-col--shaded dash-fuel-funds__content-col-container">
            <div class="dash-fuel-funds__vendors">
              <div class="dash-fuel-funds__vendor" v-for="vendor in percentages">
                <div class="dash-fuel-funds__vendor-percentage h-right-align" v-cloak>{{ vendor.percent }}%</div>
                <div class="dash-fuel-funds__vendor-name h-left-align" v-cloak>{{ vendor.vendor }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row dashboard__card-body" v-else>
        <div class="alert alert-warning">
          <div class="dashboard__no-data">No Fuel Funds information available</div>
        </div>
      </div>
      <div class="dashboard__card-footer">
        <div class="dashboard__card-link" v-if="totalAvailable">
          <router-link to="/fuel-funds" class="dashboard__card-link-text">View All</router-link>
        </div>
      </div>
    </div>
    <TermsModal></TermsModal>
  </div>

</template>

<script>
  import { mapGetters } from 'vuex';
  import TermsModal from '../../fuel-funds/TermsModal.vue';
  import CardLoading from './CardLoading.vue';

  export default {
    name: 'FuelFundsCard',
    components: {
      CardLoading,
      TermsModal,
    },
    mounted() {
      this.$store.dispatch('fuelFunds/getFuelFunds');
    },
    computed: {
      ...mapGetters('fuelFunds', ['loaders', 'totalAvailable', 'percentages']),
    },
    methods: {
      activateModal() {
        this.$store.dispatch('main/showModal', 'termsAndConditions');
      },
    }
  };
</script>
